// Portado de src/components/tratamento/CtaPratico.astro (site Astro).
import { MEDICO } from "@/lib/itv/site";
import { CardsAtendimento } from "@/components/itv/CardsAtendimento";

export interface CtaPraticoProps {
  linha1: string;
  linha2: string;
}

export function CtaPratico({ linha1, linha2 }: CtaPraticoProps) {
  return (
    <section className="cta">
      <div className="container cta-inner">
        <div className="cta-cabecalho">
          <p className="cta-eyebrow">COMO FUNCIONA O ATENDIMENTO</p>
          <h2>
            {linha1}
            <br />
            {linha2}
          </h2>
        </div>
        <CardsAtendimento />
        <p className="cta-nota">{MEDICO.crm} · NUTROLOGIA · MEDICINA DO ESPORTE · LONGEVIDADE</p>
      </div>
    </section>
  );
}
